import React from 'react'
import useScrollData from '../utils/useScrollData'

import './Carousel.sass'

// Déclaration du composant Carousel
const Carousel = ({ children, className, pagerClassName, pagerItemClassName, isSlideShow, slideShowInterval, ...rest }) => {
  if (!className || className.split(' ').indexOf('carousels') <= -1) {
    className = `${className || ''} carousels`
  }
  if (!className || className.split(' ').indexOf('is-scroll-snap-center') <= -1) {
    className = `${className || ''} is-scroll-snap-center`
  }
  if (!pagerClassName || pagerClassName.split(' ').indexOf('carousels-pager') <= -1) {
    pagerClassName = `${pagerClassName || ''} carousels-pager`
  }
  if (!pagerItemClassName || pagerItemClassName.split(' ').indexOf('carousels-pager-item') <= -1) {
    pagerItemClassName = `${pagerItemClassName || ''} carousels-pager-item`
  }

  // useRef renvoie un objet ref modifiable dont la propriété current est initialisée avec l’argument fourni.
  // L’objet renvoyé persistera pendant toute la durée de vie du composant.
  // C’est utile afin d'avoir des valeurs modifiables sous la main.
  const firstChildRef = React.useRef()
  const childrenRef = React.useRef(children)
  // Initialisation de la variable carouselData dans le state avec la valeur null. Mise en relation avec son setter setCarouselData
  const [carouselData, setCarouselData] = React.useState(null)

  // Store children inside a ref as ScrollData callback is not refreshed
  childrenRef.current = children
  // UseScrollData, observer custom, peut etre trouvé dans utils.
  const [refRailScrollData, setRefRailScrollData] = useScrollData((scrollData) => {
    let firstChildRect = null
    let pageWidth = 0
    let itemWidth = 0
    let itemGap = 0
    let pageSize = 0
    let pageCount = 0
    let firstVisibleIndex = 0
    let lastVisibleIndex = 0
    let currentPageIndex = 0

    if (firstChildRef.current && (!carouselData || scrollData.rect.width !== carouselData.rect.width)) {
      firstChildRect = firstChildRef.current.getBoundingClientRect()
    }

    if (scrollData && firstChildRect && childrenRef.current && childrenRef.current.length > 0) {
      const scrollValue = scrollData.x.value
      pageWidth = scrollData.rect.width
      itemWidth = firstChildRect.width
      pageSize = Math.floor(pageWidth / itemWidth)
      itemGap = (pageWidth - (itemWidth * pageSize)) / (pageSize + 1)
      pageCount = Math.ceil(childrenRef.current.length / pageSize)
      firstVisibleIndex = Math.floor(scrollValue / itemWidth)
      lastVisibleIndex = firstVisibleIndex + pageSize - 1
      currentPageIndex = lastVisibleIndex < childrenRef.current.length - 1 ? Math.floor(firstVisibleIndex / pageSize) : pageCount - 1

      setCarouselData({
        ...scrollData,
        itemWidth,
        pageWidth,
        pageSize,
        itemGap,
        pageCount,
        currentPageIndex
      })
    }
  })

  const childrenWithExtraProp = React.Children.map(children, (child, index) => {
    if (!child) return null
    const extraProps = {}

    if (index === 0) {
      extraProps.ref = firstChildRef
    }
    return React.cloneElement(child, extraProps)
  })

  // UseEffect => La suite d'action est lancée si une modification / update arrive sur les données écoutées
  React.useEffect(() => {
    if (isSlideShow) {
      const timer = setInterval(() => {
        if (carouselData) {
          const newPageIndex = carouselData.currentPageIndex >= carouselData.pageCount - 1 ? 0 : carouselData.currentPageIndex + 1

          refRailScrollData.current.scrollTo({
            left: carouselData.pageWidth * newPageIndex - (carouselData.itemGap * newPageIndex),
            behavior: 'smooth'
          })
        }
      }, slideShowInterval || 1000)
      // clearing interval
      return () => clearInterval(timer)
    }
    // eslint-disable-next-line
  }, [isSlideShow, slideShowInterval, carouselData])

  return (
    <>
      <div className={className} {...rest} ref={setRefRailScrollData}>
        {childrenWithExtraProp}
      </div>

      {
          children && carouselData &&
            <div className={pagerClassName}>
              {
                children.length > carouselData.pageSize && children.map((child, index) => {
                // const extraClass = index >= firstVisibleIndex && index <= lastVisibleIndex ? 'is-current' : ''
                  const extraClass = carouselData && index === carouselData.currentPageIndex * carouselData.pageSize ? 'is-current' : ''

                  if (!carouselData || index % carouselData.pageSize !== 0) return null

                  const pageIndex = Math.floor(index / carouselData.pageSize)

                  return (
                    <div
                      key={index} className={`${pagerItemClassName} ${extraClass}`}
                      onClick={() => {
                        refRailScrollData.current.scrollTo({
                          left: carouselData.pageWidth * pageIndex - (carouselData.itemGap * pageIndex),
                          behavior: 'smooth'
                        })
                      }}
                    />
                  )
                })
            }
            </div>
      }
    </>
  )
}

// Export par défault du composant
export default Carousel
